import type {
  ShortCircuitEvaluationRule,
  ShortCircuitEvaluationRuleName
} from '..';
import type { ElectricCurrentType } from '../../../domain/ElectricCurrent';
import type { AttentionStatusType } from '../../AttentionStatus';
import { AttentionStatus } from '../../AttentionStatus';
import type { EvaluatedResult } from '../../EvaluatedResult';

export const singleFaultEvaluation: SingleFaultEvaluationFunction = (
  rule,
  evaluatedValue,
  faultType,
  apply
) => {
  const attentionStatus = AttentionStatus.fromAlertScale(
    rule?.value,
    evaluatedValue.toAmperes()
  );
  apply(attentionStatus);
  return {
    value: evaluatedValue,
    status: attentionStatus,
    ruleName: faultType
  };
};

export type SingleFaultEvaluationFunction = (
  rule: ShortCircuitEvaluationRule | undefined,
  evaluatedValue: ElectricCurrentType,
  faultType: ShortCircuitEvaluationRuleName,
  apply: (attentionStatus: AttentionStatusType) => void
) => EvaluatedResult<ElectricCurrentType>;
